/**
 * Keeps every secondary CTA's hidden "quantity" field (see snippets/lp-cta-button.liquid) in
 * sync with whatever bundle tier (1/3/6 bottles) is currently selected in the buy-box, so
 * clicking "Add to Cart" anywhere on the page adds the quantity the shopper actually picked
 * instead of always adding 1.
 *
 * Reads the value right before the click's native form submission fires (not on page load or
 * via the bundle-selector's change event) so there's no race with whichever tier happens to be
 * selected at that exact moment — this always reflects the current state.
 */
document.addEventListener(
  'click',
  (event) => {
    const button = event.target instanceof Element ? event.target.closest('button[name="add"]') : null;
    if (!button) return;

    const quantityInput = button.closest('form')?.querySelector('input[name="quantity"][data-lp-cta-quantity]');
    if (!quantityInput) return;

    const nativeQuantityInput = document.querySelector('quantity-selector-component input[ref="quantityInput"]');
    const selectedTier = document.querySelector('[data-tier].lp-bundle-selector__tier--selected');
    quantityInput.value = nativeQuantityInput?.value || selectedTier?.dataset.quantity || '1';
  },
  { capture: true }
);
